export type RoleLike = string | { name?: string; role?: string } | unknown;

const OPERATOR_EQUIVALENT = new Set(['OPERATOR', 'ADMIN']);

function extractRoleName(role: RoleLike): string | undefined {
  if (typeof role === 'string') {
    return role;
  }

  if (role && typeof role === 'object') {
    const r = role as { name?: string; role?: string };
    return r.name || r.role;
  }

  return undefined;
}

export function hasOperatorLikeRole(roles: RoleLike[] | undefined): boolean {
  if (!roles || roles.length === 0) {
    return false;
  }

  return roles.some(r => OPERATOR_EQUIVALENT.has(extractRoleName(r) ?? ''));
}

export function listOperatorLikeRoles(roles: RoleLike[] | undefined): string[] {
  if (!roles) {
    return [];
  }

  const found = new Set<string>();
  roles.forEach(r => {
    const name = extractRoleName(r);
    if (name && OPERATOR_EQUIVALENT.has(name)) {
      found.add(name);
    }
  });
  return Array.from(found).sort();
}

export function isAdminRolePresent(roles: RoleLike[] | undefined): boolean {
  if (!roles) {
    return false;
  }

  return roles.some(r => {
    const name = extractRoleName(r);
    return name === 'ADMIN' || name === 'Admin';
  });
}
